// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Tooltip_arrow__OWLIa"};